import { Popover, styled } from "@mui/material";
import { SizeUnits } from "../../theme/wscTheme.types";

export const StyledColorpicker = styled("div")`
  > .react-colorful {
    width: auto;
    gap: ${(props) => props.theme.wsc.spacing[2]};

    .react-colorful__pointer {
      border-color: ${(props) => props.theme.wsc.palette.neutral[300]};
      width: ${(props) => props.theme.wsc.size.s};
      height: ${(props) => props.theme.wsc.size.s};
    }

    .react-colorful__saturation {
      border-radius: ${(props) => props.theme.wsc.radius.sm};
      border-bottom: none;
    }

    .react-colorful__hue,
    .react-colorful__alpha {
      height: ${(props) => props.theme.wsc.size.s};
      border-radius: ${(props) => props.theme.wsc.radius.l};
    }
  }
`;

export const StyledPopover = styled(Popover)`
  .MuiPaper-root {
    background: transparent;
    border-radius: ${(props) => props.theme.wsc.radius.m};
  }
`;

export const Wrapper = styled("article")`
  display: flex;
  flex-direction: column;
  gap: ${(props) => props.theme.wsc.spacing[2]};
  padding: ${(props) => props.theme.wsc.spacing[2]};
  background-color: ${(props) => props.theme.wsc.palette.neutral[700]};
  width: 18.85715rem;
`;

export const ColorInputWrapper = styled("section")`
  display: flex;
  align-items: center;
  gap: ${(props) => props.theme.wsc.spacing[1]};
`;

export const Color = styled("span")<{
  color: string;
  size?: keyof SizeUnits;
  clickable?: boolean;
}>`
  width: ${(props) => props.theme.wsc.size[props.size ?? "l"]};
  height: ${(props) => props.theme.wsc.size[props.size ?? "l"]};
  border-radius: ${(props) => props.theme.wsc.radius.half};
  background-color: ${(props) => props.color};
  ${(props) => props.clickable && `cursor: pointer`};
`;
